import React from 'react';
import ButtonIngresar from './Button';
import base64 from 'base-64'
import dataUser from '../constants/userData'
import logo from "../assets/logo.png"

class Login extends React.Component {
    constructor(props){
        super(props);
        this.state={
           seller:"",
           password:""
        }
    }

    redirectTo(value){
        this.props.redirectTo(value)
    }

    redirectToAuth(sellerAuth,token) {
        //var check = document.getElementById('custom-check-quotation').checked
        if (sellerAuth) {
            //window.location.href = AGENTOOL + base64.encode(token);
            const toke =  base64.encode(token);
            localStorage.setItem("franquicias",toke);            
            this.redirectTo(dataUser.user.passwordStatus?"Modules":"ChangePass");
        }
        // else if(!check && sellerAuth){
        //     localStorage.setItem("franquicias", base64.encode(token))
        //     this.props.redirectTo("Member Authentication")
        // }
    }

    changePass(e){
        this.setState({password:e.target.value})
    }
    changeSeller(e){
        this.setState({seller:e.target.value})
    }  

    render() {
	  return(
          <div className="container">
              <div className="row justify-content-center signup-form">
                  <div className=" col-12 col-md-9 col-lg-6 pt-20">
                      <div className="card signup-card">
                          <div className="card-head text-center px-15 p-md-15 bg-dark">
                          <div className="cp-logo pt-15">
                          <img alt="ClubPremier" width="80%" src={logo}/>
                          </div>
                

                          </div>
                          <div className="card-body px-15 p-md-30 ">
                              <div className="row justify-content-center">
                                  <div className="col-11 col-md-11 pt-11 text-center">
                                      <h2 className=" mb-20">Iniciar sesión.</h2>
                                  </div>
                                  <div className="col-11 p-10">
                                      <input className="form-control p-10" id="username" name="username" placeholder="Usuario" onChange={this.changeSeller.bind(this)}/>
                                  </div>
                                  <div className="col-11 p-10">
                                      <input className="form-control p-10" id="password" name="password" type="password" onChange={this.changePass.bind(this)} placeholder="Contraseña" />
                                  </div>
                                   {/* <div className="col-10 col-md-11 p-0 pl-md-10 pt-20">
                                      <div className="custom-control custom-checkbox">
                                          <input id="custom-check-quotation" className="custom-control-input" type="checkbox" />
                                          <label htmlFor="custom-check-quotation" className="custom-control-label">Cotización</label>
                                      </div>
                                  </div> */}
                                  <div className="col-8 pt-15 "> 
                                    <ButtonIngresar 
                                    sellerAuth={this.redirectToAuth.bind(this)} 
                                    password={this.state.password} 
                                    seller={this.state.seller}/>
                                   </div> 
                                  <div className="col-12 text-right pt-10">
                                      <hr></hr>
                                      <a className="link small " tabIndex="5" title="" onClick={this.redirectTo.bind(this,'ChangePass')}>Cambiar contraseña</a>
                                   |  <a className="link small " tabIndex="5" title="" onClick={this.redirectTo.bind(this,'ForgotPass')}> Olvidé mi Contraseña</a>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
				);
	}
	}
export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js